export const GLOBAL_REDUCER_TYPE = {
  INITGLOBALDATA: "initGlobalData",
  SET_DEVICE_TYPE: "setDeviceType",
}

export const LOCALSTORAGE_TYPE = {
  ACCESSTOKEN: "access_token",
}